/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applications_Notes_PlaceholderInputs */

const en_applications_notes_placeholder = /** @type {(inputs: Applications_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add notes about this application...`)
};

const de_applications_notes_placeholder = /** @type {(inputs: Applications_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizen zu dieser Bewerbung hinzufügen...`)
};

const fr_applications_notes_placeholder = /** @type {(inputs: Applications_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter des notes sur cette candidature...`)
};

const es_applications_notes_placeholder = /** @type {(inputs: Applications_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar notas sobre esta solicitud...`)
};

const it_applications_notes_placeholder = /** @type {(inputs: Applications_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi note su questa candidatura...`)
};

const nl_applications_notes_placeholder = /** @type {(inputs: Applications_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg notities toe over deze sollicitatie...`)
};

const pl_applications_notes_placeholder = /** @type {(inputs: Applications_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj notatki o tej aplikacji...`)
};

const fi_applications_notes_placeholder = /** @type {(inputs: Applications_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää muistiinpanoja tästä hakemuksesta...`)
};

const da_applications_notes_placeholder = /** @type {(inputs: Applications_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilføj noter om denne ansøgning...`)
};

const sv_applications_notes_placeholder = /** @type {(inputs: Applications_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lägg till anteckningar om denna ansökan...`)
};

/**
* | output |
* | --- |
* | "Add notes about this application..." |
*
* @param {Applications_Notes_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const applications_notes_placeholder = /** @type {((inputs?: Applications_Notes_PlaceholderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applications_Notes_PlaceholderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications_notes_placeholder(inputs)
	if (locale === "fr") return fr_applications_notes_placeholder(inputs)
	if (locale === "es") return es_applications_notes_placeholder(inputs)
	if (locale === "it") return it_applications_notes_placeholder(inputs)
	if (locale === "nl") return nl_applications_notes_placeholder(inputs)
	if (locale === "pl") return pl_applications_notes_placeholder(inputs)
	if (locale === "fi") return fi_applications_notes_placeholder(inputs)
	if (locale === "da") return da_applications_notes_placeholder(inputs)
	if (locale === "sv") return sv_applications_notes_placeholder(inputs)
	return en_applications_notes_placeholder(inputs)
});